import { assets } from '@/ui/assets'
import { InternalLinkButton } from '@/ui/atoms/link-button/LinkButton'
import { Panel } from '@/ui/atoms/panel/Panel'

export function SparkLendBanner() {
  return (
    <Panel spacing="m" className="flex items-center gap-3 bg-primary sm:gap-8">
      <img src={assets.points.benmoSparklendIcon} alt="benmo-sparklend-icon" className="w-[72px] md:w-[110px]" />
      <div className="flex w-full flex-col justify-between gap-3 lg:flex-row lg:items-center lg:gap-8">
        <div className="flex flex-col gap-1">
          <div className="typography-label-2 sm:typography-heading-5 text-primary">
            Borrow assets <span className="whitespace-nowrap">using SparkLend</span>
          </div>
          <div className="typography-body-4 hidden text-secondary md:block lg:max-w-[38ch]">
            Go to Borrow or My Portfolio pages to take advantage of SparkLend's features.
          </div>
        </div>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:min-w-64 lg:gap-4">
          <InternalLinkButton to="/borrow" variant="secondary" size="m">
            Go to Borrow
          </InternalLinkButton>
          <InternalLinkButton to="/my-portfolio" variant="secondary" size="m" className="hidden md:flex">
            Go to My Portfolio
          </InternalLinkButton>
        </div>
      </div>
    </Panel>
  )
}
